// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-misused-promises */

import * as types from "./actionTypes";
import * as autoAlignApi from "../../apis/autoAlignApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

/*
 *  Action Creators
 *
 */

export function alignPlotsSuccess() {
	return { type: types.ANALYSIS_ALIGN_PLOTS_SUCCESS };
}

/*
 *  Thunks
 *
 */

export function alignPlots(objectToPass, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return autoAlignApi
				.alignPlots(objectToPass, clientId, accessToken)
				.then((result) => {
					if (result.statusCode !== 200) {
						reject(result);
						dispatch(apiCallError(result));
					} else {
						dispatch(alignPlotsSuccess());
						resolve(result.data);
					}
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}
